'use strict';

import React from 'react';

function Footer() {
  return (
    <footer className="mt-4 pt-3 border-top text-end text-muted">
      <small>
        Developed by <a href="http://webbylab.com" target="_blank" rel="noopener noreferrer">WebbyLab</a>
      </small>
    </footer>
  );
}

export default Footer;
